export default {
  dev: {
    admin: 'https://admin.skordev.com',
    app: 'https://vineet.skordev.com/',
    basePath: 'https://pwa.skordev.com/#/',
    img: 'https://vineet.skordev.com',
    SSOUrl: '',
    sentryReplay: '',
    flexiUrl: '',
    externalAuthUrl: '',
    ascendUrl: '',
    opusUrl: '',
  },
  prod: {
    admin: 'https://admin.cerrapoints.com',
    app: 'https://cerrapoints.com/',
    basePath: 'https://pwa.cerrapoints.com/#/',
    img: 'https://cerrapoints.in',
    SSOUrl: '',
    sentryReplay: '',
    flexiUrl: '',
    externalAuthUrl: '',
    ascendUrl: '',
    opusUrl: '',
  },
};
